/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Extra_Ask_Pick_ManyInputs */

const en_us2_coach_extra_ask_pick_many = /** @type {(inputs: Coach_Extra_Ask_Pick_ManyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose one or more`)
};

const pt_br2_coach_extra_ask_pick_many = /** @type {(inputs: Coach_Extra_Ask_Pick_ManyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha uma ou mais`)
};

const es_419_coach_extra_ask_pick_many = /** @type {(inputs: Coach_Extra_Ask_Pick_ManyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige una o más`)
};

const pt_pt2_coach_extra_ask_pick_many = /** @type {(inputs: Coach_Extra_Ask_Pick_ManyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolhe uma ou mais`)
};

const fr_fr2_coach_extra_ask_pick_many = /** @type {(inputs: Coach_Extra_Ask_Pick_ManyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisis-en une ou plusieurs`)
};

const de_de2_coach_extra_ask_pick_many = /** @type {(inputs: Coach_Extra_Ask_Pick_ManyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle eine oder mehrere`)
};

const it_it2_coach_extra_ask_pick_many = /** @type {(inputs: Coach_Extra_Ask_Pick_ManyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegline una o più`)
};

/**
* | output |
* | --- |
* | "Choose one or more" |
*
* @param {Coach_Extra_Ask_Pick_ManyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_extra_ask_pick_many = /** @type {((inputs?: Coach_Extra_Ask_Pick_ManyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Extra_Ask_Pick_ManyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_extra_ask_pick_many(inputs)
	if (locale === "es-419") return es_419_coach_extra_ask_pick_many(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_extra_ask_pick_many(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_extra_ask_pick_many(inputs)
	if (locale === "de-DE") return de_de2_coach_extra_ask_pick_many(inputs)
	if (locale === "it-IT") return it_it2_coach_extra_ask_pick_many(inputs)
	return en_us2_coach_extra_ask_pick_many(inputs)
});
export { coach_extra_ask_pick_many as "coach-extra.ask_pick_many" }